import classnames from 'classnames';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import type { SortKey } from './types';

export function SortSelect({
  sortKey,
  sortDirection,
  onSort,
}: {
  sortKey: SortKey;
  sortDirection: 'ASC' | 'DESC' | null;
  onSort: (key: 'ASC' | 'DESC') => void;
}): JSX.Element {
  return (
    <div className="sort-select">
      <div className="sort-select-key">{t(`sort.${sortKey}`)}</div>
      <div className="sort-select-values">
        <div
          className={classnames('sort-select-value', { active: sortDirection === 'DESC' })}
          {...onClickGenerator(() => onSort('DESC'))}
        >
          {sortDirection === 'DESC' ? (
            <i className="fas fa-caret-square-down" />
          ) : (
            <i className="fas fa-caret-down" />
          )}
        </div>
        <div
          className={classnames('sort-select-value', { active: sortDirection === 'ASC' })}
          {...onClickGenerator(() => onSort('ASC'))}
        >
          {sortDirection === 'ASC' ? (
            <i className="fas fa-caret-square-up" />
          ) : (
            <i className="fas fa-caret-up" />
          )}
        </div>
      </div>
    </div>
  );
}
